import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "fwdRef", "stacked"];
import React, { createContext, forwardRef, useContext, useState } from 'react';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
import { FormContext } from '../form/form';
export const ButtonRowContext = /*#__PURE__*/createContext({
  registerPrimary: () => undefined,
  stacked: false
});
/**
 * _Group of related buttons that spaces and positions them responsively in a row or a stack._
 *
 * ***
 *
 * A row (or a stack with the `xs` breakpoint) of buttons, primarily used at
 * the end of a form or other process views. The component children are
 * expected to be [`<Button>`](#/Actions/Button) components. Additional props
 * (including `ref`) will be forwarded to the wrapping `<div>` element.
 */

export const ButtonRow = _ref => {
  let {
      children,
      className,
      fwdRef,
      stacked: stackedProp
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [primary, setPrimary] = useState(false);
  const {
    stacked: stackedContext
  } = useContext(FormContext);
  const stacked = stackedProp !== undefined ? stackedProp : stackedContext;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: buildVersionedClassNames('ds-button-row', className, {
      'ds-button-row--primary': primary,
      'ds-button-row--unstacked': !stacked
    }),
    ref: fwdRef
  }), /*#__PURE__*/React.createElement(ButtonRowContext.Provider, {
    value: {
      registerPrimary: () => setPrimary(true),
      stacked: stackedProp
    }
  }, children));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(ButtonRow, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'ButtonRow';
export default Fwd;